import { NextPage } from "next"

import Eia from './theme/eia'
import type { IFile, IAllowFileExtensions, IMaxSize } from './interfaces'

interface IProps {
  theme?: 'eia' | 'default';
  className?: string;
  isMultiple?: boolean;
  allowExtensions?: IAllowFileExtensions;
  allowMaxSize?: IMaxSize;
  existingItems?: Record<string, any>[];
  handler?: (files: IFile[], existingItems?: any) => void;
  downloadHandler?: (id: string) => void;
}

const Component: NextPage<IProps> = ({ theme, className, isMultiple, allowExtensions, allowMaxSize, existingItems, handler, downloadHandler }) => {
  const setTheme = theme || 'default';
  const maxSize = allowMaxSize || '5MB';
  const multiple = isMultiple || false;

  switch(setTheme) {
    case 'default':
    default:
      return <Eia className={className} isMultiple={multiple} allowExtensions={allowExtensions} allowMaxSize={maxSize} existingItems={existingItems} handler={handler} downloadHandler={downloadHandler} />
  }
}

export default Component;